import BaseFormView from "scripts/views/baseFormView";
import templateContentDetailsPageNoteForm from "templates/contentDetailsPageNoteForm.hbs";

class ContentDetailsPageNoteFormView extends BaseFormView {
  get template() {
    return templateContentDetailsPageNoteForm;
  }

  get constraints() {
    return {
      text: {
        presence: true,
      },
    };
  }

  get events() {
    return {
      "click #bb-content-details-page-note-form-cancel": "onClickCancel",
      "blur form *[name]": "onBlurValidate",
      "input form *[name]": "onInputEnableSubmit",
      "submit form": "onSubmit",
    };
  }

  constructor(options) {
    super(options);

    this.model.constraints = this.constraints;

    this.bindModel(this.model);
  }

  render() {
    this.$el.html(this.template(this.model.toJSON()));

    this.loaderView
      .appendTo(this.$el.find(".bb-form-submit-button-loader-region"))
      .render();

    this.enableSubmit(this.isValid());

    return this;
  }

  onClickCancel() {
    this.trigger("cancel");
  }
}

export default ContentDetailsPageNoteFormView;
